import { CommonModule } from '@angular/common';
import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, IonInput, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { TeamDetailsService } from '../team-details.service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { NgOtpInputModule } from 'ng-otp-input';
import { ToastService } from '../../../_core/services/toast.service';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  imports: [CommonModule, FormsModule, IonicModule, NgOtpInputModule]
})
export class VerifyEmailComponent {
  @Input() email!: string;
  @Input() teamId!: string;
  @ViewChildren(IonInput) inputs!: QueryList<IonInput>;
  public otpValue: string = '';
  private readonly destroy$: Subject<void> = new Subject();
  isLoading: boolean = true;
  showOtp = true;

  constructor(private modalController: ModalController, private router: Router,
    private teamDetailsService: TeamDetailsService,
    private toastController: ToastService
  ) { }

  onOtpChange(otp: string) {
    this.otpValue = otp;
    if (this.otpValue.length == 6) {
      this.submit();
    }
  }

  submit() {
    const code = this.otpValue;
    this.verifyClaimCoach(code);
  }

  close() {
    this.modalController.dismiss({ confirmed: true }, 'cancel');
  }

  resendCode() {
    this.reInitiateClaim(this.email);
    // API call to resend code
  }

  async claimCoach(email: string) {
    if (this.teamId) {
      this.isLoading = true;
      this.teamDetailsService
        .startClaimCoach(this.teamId, email)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => this.isLoading = false))
        .subscribe({
          next: async (res) => {
            this.isLoading = false;
          },
          error: async (err) => {
            this.isLoading = false;
            this.toastController.presentDangerToast(err?.error?.message || err?.message || 'Error initiating claim, Please try again.');
          }
        });
    }
  }

  async reInitiateClaim(email: string) {
    if (this.teamId) {
      this.isLoading = true;
      this.teamDetailsService
        .reInitiateClaimCoach(this.teamId, email)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => this.isLoading = false))
        .subscribe({
          next: async (res) => {
            this.isLoading = false;
            this.toastController.presentToast(res?.message ?? 'We have sent you a new OTP.');
          },
          error: async (err) => {
            this.isLoading = false;
            this.toastController.presentDangerToast(err?.error?.message || err?.message || 'Error initiating claim, Please try again.');
          }
        });
    }
  }

  contactUs() {
    this.close();
    this.router.navigate(['/feedback']);
  }

  async verifyClaimCoach(code: string) {
    if (this.teamId) {
      this.teamDetailsService
        .verifyClaimCoach(this.teamId, code)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => this.isLoading = false))
        .subscribe({
          next: async (res) => {
            this.isLoading = false;
            this.modalController.dismiss({ confirmed: true });
            this.toastController.presentToast(res?.message ?? 'Your account has been successfully claimed.');
          },
          error: async (err) => {
            this.showOtp = false;
            this.otpValue = "";
            setTimeout(() => this.showOtp = true, 0);
            this.toastController.presentDangerToast(err?.error?.message || err?.message || 'Invalid OTP, Please try again.');
          }
        });
    }
  }
}
